module.exports = __webpack_public_path__ + "static/media/masafy.358fba9c.webp";